<template>
  <div class="page-exchange">

    <div class="header-top">
      <p>当前能量</p>
      <div class="c_num">
        {{ $store.state.user.coinNum }}
      </div>
      <div class="yui_desc2">
        <van-icon class="y-icon" name="warning"
                  color="#117A28"/>
        <span>6月30日24时清零</span>
      </div>
    </div>
    <!--    爱奇艺月卡：AQYYKDTZY20210219172455157
        爱奇艺季卡：AQYJKDTZY20210219172509828
        京东E卡10元：JDEK10YDTZY20210219172528980
        京东E卡50元：JDEK50YDTZY20210219172548876
        京东E卡100元：JDEK100YDTZY20210219172604379
        美团外卖5元：MTWM5YDTZY20210219172638240-->

    <div class="yui_card">
      <span style="font-size: 4.8vw;font-weight: 500;">能量兑换</span>
      <!--
            <div class="exchange_coupon">
              <div class="yui_icon">

                <img src="../../assets/icon-aqiyi.png" alt="">
              </div>
              <div class="coupon-info">
                <h5>爱奇艺月卡</h5>

                <div class="y-link" @click="toExchangeDetail('AQYYKDTZY20210219172455157')">
                  查看细则
                  <van-icon name="arrow"
                            size="3vw"/>
                </div>
              </div>

              <div class="yui_ft">
                <p>
                  30个能量
                </p>
                <van-button round
                            plain
                            class="yui_btn-exchange"
                            hairline
                            size="mini"
                            @click="exchangeActivationCode('AQYYKDTZY20210219172455157','爱奇艺月卡',30)"
                            type="warning">
                  立即兑换
                </van-button>
              </div>
            </div>





            <div class="exchange_coupon">
              <div class="yui_icon">

                <img src="../../assets/icon-aqiyi.png" alt="">
              </div>
              <div class="coupon-info">
                <h5>爱奇艺季卡</h5>

                <div class="y-link" @click="toExchangeDetail('AQYJKDTZY20210219172509828')">
                  查看细则
                  <van-icon name="arrow"
                            size="3vw"/>
                </div>
              </div>

              <div class="yui_ft">
                <p>
                  90个能量
                </p>
                <van-button round
                            plain
                            class="yui_btn-exchange"
                            hairline
                            size="mini"
                            @click="exchangeActivationCode('AQYJKDTZY20210219172509828','爱奇艺季卡',90)"
                            type="warning">
                  立即兑换
                </van-button>
              </div>
            </div>
      -->


      <!--      <exchange-card name="2元钱包地铁乘车券"-->
      <!--                     coin-num="4"-->
      <!--                     @handToDetail="handToDetail1"-->
      <!--                     v-on:handExchange="exchange1">-->

      <!--        <img slot="icon" src="../../assets/icon-metro.png" alt="">-->

      <!--      </exchange-card>-->
      <exchange-card v-for="(item,index) in exchangeList"
                     :key="'e_'+index"
                     :name="item.productName"
                     :coin-num="item.coinNum"
                     :product-id="item.productId"
                     @handToDetail="toExchangeDetail(item.productId)"
                     v-on:handExchange="exchangeActivationCode(item)">

        <img slot="icon" :src="item.icon" alt="">

      </exchange-card>
      <!--      <div class="yui_coupon" v-for="i in 6" :key="i">-->
      <!--        <div class="yui_icon">-->
      <!--          <img src="../../assets/icon-meituan.png" alt="">-->
      <!--        </div>-->
      <!--        <div class="coupon-info">-->
      <!--          <h5>2元钱包地铁乘车券</h5>-->

      <!--          <div class="y-link">-->
      <!--            查看细则-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="yui_ft">-->
      <!--          <p>-->
      <!--            4个能量-->
      <!--          </p>-->
      <!--          <van-button round-->
      <!--                      plain-->
      <!--                      hairline-->
      <!--                      size="mini"-->
      <!--                      type="warning">-->
      <!--            立即兑换-->
      <!--          </van-button>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <van-dialog v-model="dialogExchangeCodeShow"
                title="兑换成功"
                confirm-button-text="查看使用说明"
                confirm-button-color="#2FBD4B"
                @confirm="toExchangeDetail(onExchangeCodeObj.productId)"

                show-cancel-button>
      <p style="margin:1em 0 0.5em;">
        权益兑换码为： <br>
        {{ onExchangeCodeObj.param }}
      </p>
      <van-button round
                  style="margin-bottom: 1.5em;"
                  data-clipboard-action="copy"
                  :data-clipboard-text="onExchangeCodeObj.param"
                  @click="copyExchangeCode"
                  class="y_btn cobyOrderSn"
                  plain hairline
                  type="warning"
                  size="small"
                  color="#2FBD4B">
        复制兑换码
      </van-button>

    </van-dialog>

    <van-dialog v-model="dialogExchangePhoneBillShow"
                :title="onExchangePhoneBillObj.productName"
                confirm-button-text="确认兑换"
                confirm-button-color="#2FBD4B"
                @confirm="toExchangePhoneBill(onExchangeCodeObj.productId)"
                :before-close="dialogExchangePhoneBillBeforeClose"
                show-cancel-button>
      <p style="font-size: 3vw;color: #999999">
        将消耗{{ onExchangePhoneBillObj.coinNum }}能量
      </p>
      <label class="yui-input-box">
        <input class="yui-input"
               type="tel"
               name="phone"
               id="phoneTel"
               v-model="dialogPhone"
               v-number-only
               maxlength="11"
               placeholder="请输入充值手机号">
      </label>
    </van-dialog>

  </div>
</template>

<script>
import exchangeCard from "@/views/exchange/components/exchangeCard";
import {costCoin} from "@/services/api";

import exchangeList from "@/views/exchange/exchangeList";

import {
  deepClone,
  phoneFilter2
} from "@/libs/tools";

export default {
  name: "exchange",
  components: {
    exchangeCard
  },
  data() {
    return {
      exchangeList,
      dialogExchangeCodeShow: false,
      dialogExchangePhoneBillShow: false,
      onExchangeCodeObj: {
        expire: "",
        param: "",
        status: ""
      },
      onExchangePhoneBillObj: {},
      dialogPhone: ''
    }
  },
  directives: {
    numberOnly: {
      bind: function (el) {
        el.handler = function () {
          el.value = el.value.replace(/\D+/, '')
        }
        el.addEventListener('input', el.handler)
      },
      unbind: function (el) {
        el.removeEventListener('input', el.handler)
      },


    }
  },
  computed: {
    phoneState() {
      return /^1[3456789]\d{9}$/.test(this.dialogPhone);
    },
    phoneFilter: function (tel) {
      // var tel = 19812311111;
      tel = "" + tel;
      // d表示数字0-9,{3}表示需要3个，所以d{3}就是表示3个数字
      var reg = /(\d{3})\d{4}(\d{4})/;
      //$1是第一个小括号里的 ,$2是第2个小括号里的
      return tel.replace(reg, "$1****$2")

    }
  },
  filters:{
    phoneFilter: function (tel) {
      // var tel = 19812311111;
      tel = "" + tel;
      // d表示数字0-9,{3}表示需要3个，所以d{3}就是表示3个数字
      var reg = /(\d{3})\d{4}(\d{4})/;
      //$1是第一个小括号里的 ,$2是第2个小括号里的
      return tel.replace(reg, "$1****$2")

    }
  },
  mounted() {
    this.$store.dispatch('handGetUserCoinInfo', {
      token: this.$store.state.user.token,
      deviceCoding: this.$store.state.user.deviceCoding
    }).then(res => {
      console.log(res)

    }).catch(err => {
      this.$toast(err)
      console.error(err)
    })
  },
  methods: {
    dialogExchangePhoneBillBeforeClose(action, done) {
      if (action === "confirm") {
        if (!this.phoneState) {
          return done(false)
        } else {
          return done()
        }

      } else {

        return done()
      }

    },
    copyExchangeCode() {
      let _this = this;
      let clipboard = new this.clipboard(".cobyOrderSn");
      clipboard.on('success', function () {
        _this.$toast("复制成功")
      });
      clipboard.on('error', function () {
        _this.$toast("复制失败")
      });
    },
    exchange1() {
      console.log(1)
    },
    handToDetail1() {
      console.log(2)
    },
    toExchangeDetail(productId) {
      this.$router.push({
        path: '/activationCode',
        query: {
          productId: productId
        }
      })
    },
    exchangeAqy() {
      this.exchangeActivationCode('AQYYKDTZY20210219172455157', '爱奇艺月卡')
    },
    exchangeActivationCode(obj) {
      if(obj.coinNum>this.$store.state.user.coinNum){
        this.$toast('能量不足')
        return false;
      }
      if (obj.type === 3) {
        this.onExchangePhoneBillObj = deepClone(obj)
        this.dialogPhone = '';
        this.dialogExchangePhoneBillShow = true;

      } else {
        let that = this
        this.$dialog.confirm({
          title: `${obj.productName}`,
          message: `将消耗${obj.coinNum}能量`,
          confirmButtonColor: '#2FBD4B',
          confirmButtonText: '确认兑换'
        })
            .then(() => {
              // on confirm
              that.exchangeActivationCodeAjax(obj.productId, obj.productName, obj.type)
            })
            .catch(() => {
              // on cancel

            })
      }

    },
    /**
     *
     * @param productId 产品编码
     * @param productName  产品名称（例如：5元话费券）
     * @param type
     * @param mobileNo 手机号（充值手机号，可为空）
     */
    exchangeActivationCodeAjax(productId = '', productName = '', type = 2) {
      console.log(type)
      let that = this

      let robj = new FormData();

      robj.append('token', this.$store.state.user.token)
      robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      robj.append('productId', productId)
      robj.append('productName', productName)

      costCoin(robj).then(res => {
        console.log(res)
        if (res.respcod === '01') {
          this.$store.dispatch('handGetUserCoinInfo', {
            token:this.$store.state.user.token,
            deviceCoding:this.$store.state.user.deviceCoding
          }).then(res => {
            console.log(res)
          })
          if (type === 2) {
            if (res.data.status === '01') {
              that.onExchangeCodeObj.param = res.data.param
              that.onExchangeCodeObj.productId = productId
              that.dialogExchangeCodeShow = true
            } else if (res.data.status === '02') {
              this.$toast('获取失败')
            }
          } else if (type === 1) {
            this.$dialog.confirm({
              title: `兑换成功`,
              message: `已发放至${phoneFilter2(that.$store.state.user.phone)}账号`,
              confirmButtonColor: '#2FBD4B',
              confirmButtonText: '查看使用说明'
            })
                .then(() => {
                  // on confirm

                  this.$router.push({
                    path: '/activationCode',
                    query: {
                      productId: productId
                    }
                  })
                })
                .catch(() => {
                  // on cancel

                })
          }


          console.log(1)
        } else {
          this.$toast(res.respmsg)
          this.$store.dispatch('handGetUserCoinInfo', {
            token:this.$store.state.user.token,
            deviceCoding:this.$store.state.user.deviceCoding
          }).then(res => {
            console.log(res)
          })
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
    toExchangePhoneBill() {
      console.log('toExchangePhoneBill')
      let that = this

      // if (this.prepaidRefillAjaxStatus) {
      //   return false;
      // }
      if (this.dialogPhone==='') {
        this.$toast('手机号不能为空')
        return false;
      }
      if (!this.phoneState) {
        this.$toast('手机号格式错误')
        return false;
      }
      if (window._czc) {

        window._czc.push(['_trackEvent', '绿色能量6月', '话费充值', '', 1, '']);

      }
      let robj = new FormData();

      robj.append('token', this.$store.state.user.token)
      robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      robj.append('productId', this.onExchangePhoneBillObj.productId)
      robj.append('productName', this.onExchangePhoneBillObj.productName)
      robj.append('mobileNo', this.dialogPhone)

      costCoin(robj).then(res => {

        if (res.respcod === '01') {
          this.$store.dispatch('handGetUserCoinInfo', {
            token:this.$store.state.user.token,
            deviceCoding:this.$store.state.user.deviceCoding
          }).then(res => {
            console.log(res)
          })
          // that.onExchangeCodeObj.param = res.data.param
          // that.onExchangeCodeObj.productId = productId
          // that.dialogExchangePhoneBillShow = false
          this.$dialog.confirm({
            title: `兑换成功`,
            message: `充值结果稍有延迟，请耐心等待`,
            confirmButtonColor: '#2FBD4B',
            confirmButtonText: '查看使用说明'
          })
              .then(() => {
                // on confirm

                this.$router.push({
                  path: '/activationCode',
                  query: {
                    productId: that.onExchangePhoneBillObj.productId
                  }
                })
              })
              .catch(() => {
                // on cancel

              })

        } else {
          this.$toast(res.respmsg)
          this.$store.dispatch('handGetUserCoinInfo', {
            token:this.$store.state.user.token,
            deviceCoding:this.$store.state.user.deviceCoding
          }).then(res => {
            console.log(res)
          })
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    }


  }
}
</script>

<style lang="less" scoped>
.page-exchange {
  //background-color: #f7f7f7;
  //padding: 20px;
  background-image: url("../../assets/exchange-top.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center top;
}

.header-top {
  padding: 5vw 5vw 2vw;
  text-align: center;
  height: 15vw;
  position: relative;
  p {

    font-size: 3vw;

    font-weight: 400;
    color: #FFFFFF;
    margin: 0 0 1vw;

  }

  .c_num {
    margin: 0;
    font-size: 10vw;

    font-weight: 500;
    color: #FFFFFF;

  }
  .yui_desc2 {
    position: absolute;
    display: flex;
    align-items: center;
    font-size: 3vw;
    top: 5vw;
    right: 3vw;
    line-height: 1;
    color: #117A28;
    .y-icon {
      font-size: 3vw;
      transform: scale(1.2);
    }

    span {
      margin-left: 0.3em;
    }
  }
}

.yui_card {
  margin: 4vw;
  padding: 3vw;
  background-color: #FFFFFF;
  text-align: left;
  border-radius: 3vw;


}

.y_card {

  border: 1px solid #999;
  border-radius: 10px;
  margin: 10px;
  overflow: hidden;

  .y_card-hd {
    background-color: #f7f7f7;
    padding: 10px;
  }

  .y_card-bd {
    padding: 10px;
    font-size: 12px;
    color: #999999;
    background-color: #ffffff;
    text-align: justify;

  }

}

.y-card-btn-box {
  padding: 0 10px;
}


.yui_coupon {
  display: flex;
  align-items: center;
  position: relative;
  background: #FFF7F3;
  padding: 3vw;
  margin: 3vw;
  border-radius: 2vw;

  &:before {
    position: absolute;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    background-color: #FFFFFF;
    content: " ";
    left: -1.5vw;
    top: calc(50% - 1.5vw);

  }

  &:after {
    position: absolute;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    background-color: #FFFFFF;
    content: " ";
    right: -1.5vw;
    top: calc(50% - 1.5vw);

  }

  .yui_icon {
    width: 7vw;
    margin-right: 2vw;

    img {
      width: 100%;
    }
  }

  .coupon-info {
    flex: 1;

    h5 {
      margin: 0;
      font-size: 14px;

      font-weight: 500;
      color: #595959;
      line-height: 20px;
    }

    .y-link {

      font-size: 10px;

      font-weight: 400;
      color: #999999;
      line-height: 14px;
    }
  }

  .yui_ft {
    width: 18vw;
    text-align: center;

    p {
      margin: 0;

      font-size: 10px;

      font-weight: 400;
      color: #2FBD4B;
      line-height: 14px;
    }
  }
}

.yui-input-box {
  width: 70vw;
  display: block;
  margin-top: 2vw;
  margin-bottom: 3vw;
  margin-left: auto;
  margin-right: auto;
  //background-color: #F5F5F5;

  .yui-input {
    max-width: 100%;
    border: none;
    font-size: 3.75vw;
    padding: 3vw 5vw;
    background-color: #F5F5F5 !important;
    border-radius: 2vw;
    height: 5vw;
    line-height: 3.75vw;
    width: 60vw;
    color: #595959 !important;
    text-align: center;

    &::placeholder {
      font-size: 3.75vw;
      line-height: 4vw;
      color: #b3b3b3;
    }

    &:disabled {
      opacity: 1 !important;
    }

    &:focus,
    &:hover {
      background-color: #ffffff70;
      color: #fad7c5;
    }
  }
}

</style>